let util = {

};
util.titleMeta = function(meta) {
	var title = meta.title ? meta.title : '';
	document.title = title;
	
	suni.postMessage({
		data: {
			action: 'api',
			methods: 'setNavigationBarTitle',
			params: {
				title:title || "活动页"
			}
		}
	});
	
};

util.userAgent = function() {
	var u = navigator.userAgent;
	return { //移动终端浏览器版本信息
		mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
		ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
		android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
		iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
		iPad: u.indexOf('iPad') > -1, //是否iPad
		isApp: true, //u.indexOf('cangshutuan') > -1 || u.indexOf('uni-app') > -1, // uni-app内核
		userAgent: u
	}
}

const windowUrl = window.location.href; // 当前网页
const windowUserAgent = navigator.userAgent;

util.isShare = windowUrl.match(/petShareFrom/i)

util.isMobile = windowUserAgent.match(/AppleWebKit.*Mobile/i)

util.isIos = windowUserAgent.match(/iPhone|iPod|iPad/i)

util.isAndroid = windowUserAgent.match(/Android/i)

util.isWeixin = windowUserAgent.match(/MicroMessenger/i)

util.unique = function(t) {
	for (var e, i = [], n = {}, a = 0; null != (e = t[a]); a++) n[e] || (i.push(e), n[e] = !0);
	return i
};

util.obj2Url = function(t) {
	var e = "";
	for (var i in t) "" != e && (e += "&"), e += i + "=" + encodeURIComponent(t[i]);
	return e
};

/**
 * 根据KEY 获取当前的URL参数
 */
util.queryString = function(t) {
	return (document.location.search.match(new RegExp("(?:^\\?|&)" + t + "=(.*?)(?=&|$)")) || ["", null])[1]
};

/**
 * 获取TOKEN
 */
util.getToken = function() {
	var token = util.queryString("token");
	return decodeURIComponent(token);
}

/**
 * 检测是否手机号
 */
util.issTel = function(t) {
	var e = new RegExp(/^1[34578]\d{9}$/),
		i = t.match(e);
	return !!i
};

/**
 * 动态插入CSS/JS
 * @param 插入的文件 远程网址
 * @param 插入成功回调
 */
util.loadFile = function(t, e) {
	var i;
	t.match(/\.js/i) ? (i = document.createElement("script"), i.src = t, document.body.appendChild(i)) : (i =
			document.createElement("link"), i.href = t, i.rel = "stylesheet", document.head.appendChild(i)), i.onload =
		i.onreadystatechange = function() {
			this.readyState && "loaded" != this.readyState && "complete" != this.readyState || e && e()
		}
};

export default util;
